import { Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { DashboardLayout } from "@/components/layout/DashboardLayout";
import LandingPage from "@/pages/LandingPage";

export function RootGate() {
  const { user, demoLogin } = useAuth();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get("embed") === "1";
  const [embedState, setEmbedState] = useState("idle");

  useEffect(() => {
    if (user === false && isEmbed && embedState === "idle") {
      setEmbedState("loading");
      demoLogin()
        .then(() => setEmbedState("done"))
        .catch(() => setEmbedState("error"));
    }
  }, [user, isEmbed, embedState, demoLogin]);

  if (user === null || (isEmbed && embedState === "loading")) {
    return (
      <div className="flex h-screen items-center justify-center gap-2 text-sm text-slate-500" data-testid="auth-loading">
        <Loader2 className="w-4 h-4 animate-spin" />
        {isEmbed ? "Открываем демо-кабинет…" : "Загрузка…"}
      </div>
    );
  }

  if (user === false) {
    if (isEmbed && embedState === "error") {
      return (
        <div className="flex h-screen flex-col items-center justify-center gap-3 px-6 text-center text-sm text-red-500" data-testid="embed-demo-error">
          Не удалось открыть демо-кабинет.
          <button
            onClick={() => setEmbedState("idle")}
            className="rounded-lg border border-red-200 px-4 py-1.5 text-red-600 hover:bg-red-50"
            data-testid="embed-demo-retry-btn"
          >
            Повторить
          </button>
        </div>
      );
    }
    if (isEmbed) {
      return (
        <div className="flex h-screen items-center justify-center gap-2 text-sm text-slate-500" data-testid="auth-loading">
          <Loader2 className="w-4 h-4 animate-spin" /> Открываем демо-кабинет…
        </div>
      );
    }
    if (location.pathname === "/") return <LandingPage />;
    return <Navigate to="/login" replace />;
  }

  return <DashboardLayout />;
}
